import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import EnhanceDropDown from "theme/components/molecules/DropDown/EnhanceDropDown";
import ToggleButton from "theme/components/atoms/ToggleButton";

const ExpandableCard = EnhanceDropDown()(
  ({ expanded, onToggle, preview, children, appearance }) => {
    const className = classnames("expandable-card", {
      [`expandable-card--${appearance}`]: appearance,
      "expandable-card--expanded": expanded,
    });

    return (
      <div className={className}>
        <div className="expandable-card__header" onClick={onToggle}>
          {preview()}
          <ToggleButton onToggle={onToggle} expanded={expanded} />
        </div>
        {expanded && (
          <div className="expandable-card__content">{children()}</div>
        )}
      </div>
    );
  }
);

ExpandableCard.propTypes = {
  preview: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  appearance: PropTypes.oneOf(["default", "inline"]),
};

export default ExpandableCard;
